"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const bulkDeleteDrippingStepper_1 = __importDefault(require("./bulkDeleteDrippingStepper"));
const bulkNewDrippingStepper_1 = __importDefault(require("./bulkNewDrippingStepper"));
const bulkWizardActionsContext_1 = __importDefault(require("../contexts/bulkWizardActionsContext"));
const useSetClassesForDripping_1 = __importDefault(require("../hooks/useSetClassesForDripping"));
const types_1 = require("../types");
const mapStateToProps = (stores) => ({
    currentBulkWizardAction: stores.BulkDrippingStore.currentBulkWizardAction
});
const BulkDrippingWizard = ({ currentBulkWizardAction, ...contextProps }) => {
    const { refetchClasses } = (0, useSetClassesForDripping_1.default)({
        isBulkOperation: true
    });
    (0, react_1.useEffect)(() => {
        if (currentBulkWizardAction === types_1.BulkWizardActions.New) {
            refetchClasses();
        }
    }, [currentBulkWizardAction, refetchClasses]);
    if (!currentBulkWizardAction) {
        return null;
    }
    const renderComponentByAction = () => {
        const ACTION_COMPONENTS = {
            [types_1.BulkWizardActions.New]: (0, jsx_runtime_1.jsx)(bulkNewDrippingStepper_1.default, {}),
            [types_1.BulkWizardActions.Delete]: (0, jsx_runtime_1.jsx)(bulkDeleteDrippingStepper_1.default, {})
        };
        return ACTION_COMPONENTS[currentBulkWizardAction];
    };
    return ((0, jsx_runtime_1.jsx)(bulkWizardActionsContext_1.default.Provider, { value: contextProps, children: renderComponentByAction() }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(mapStateToProps))(BulkDrippingWizard);
